export { default } from "./AdvisorTeamLockedMember";
